// Comprehensive database of major cities with IANA timezone identifiers
export const CITIES_DATABASE = [
  // North America
  { city: 'New York', country: 'United States', timezone: 'America/New_York' },
  { city: 'Los Angeles', country: 'United States', timezone: 'America/Los_Angeles' },
  { city: 'Chicago', country: 'United States', timezone: 'America/Chicago' },
  { city: 'Houston', country: 'United States', timezone: 'America/Chicago' },
  { city: 'Phoenix', country: 'United States', timezone: 'America/Phoenix' },
  { city: 'Philadelphia', country: 'United States', timezone: 'America/New_York' },
  { city: 'San Antonio', country: 'United States', timezone: 'America/Chicago' },
  { city: 'San Diego', country: 'United States', timezone: 'America/Los_Angeles' },
  { city: 'Dallas', country: 'United States', timezone: 'America/Chicago' },
  { city: 'San Jose', country: 'United States', timezone: 'America/Los_Angeles' },
  { city: 'Austin', country: 'United States', timezone: 'America/Chicago' },
  { city: 'Jacksonville', country: 'United States', timezone: 'America/New_York' },
  { city: 'San Francisco', country: 'United States', timezone: 'America/Los_Angeles' },
  { city: 'Columbus', country: 'United States', timezone: 'America/New_York' },
  { city: 'Indianapolis', country: 'United States', timezone: 'America/Indiana/Indianapolis' },
  { city: 'Seattle', country: 'United States', timezone: 'America/Los_Angeles' },
  { city: 'Denver', country: 'United States', timezone: 'America/Denver' },
  { city: 'Washington', country: 'United States', timezone: 'America/New_York' },
  { city: 'Boston', country: 'United States', timezone: 'America/New_York' },
  { city: 'Detroit', country: 'United States', timezone: 'America/Detroit' },
  { city: 'Nashville', country: 'United States', timezone: 'America/Chicago' },
  { city: 'Portland', country: 'United States', timezone: 'America/Los_Angeles' },
  { city: 'Las Vegas', country: 'United States', timezone: 'America/Los_Angeles' },
  { city: 'Miami', country: 'United States', timezone: 'America/New_York' },
  { city: 'Toronto', country: 'Canada', timezone: 'America/Toronto' },
  { city: 'Montreal', country: 'Canada', timezone: 'America/Toronto' },
  { city: 'Vancouver', country: 'Canada', timezone: 'America/Vancouver' },
  { city: 'Calgary', country: 'Canada', timezone: 'America/Edmonton' },
  { city: 'Ottawa', country: 'Canada', timezone: 'America/Toronto' },
  { city: 'Mexico City', country: 'Mexico', timezone: 'America/Mexico_City' },
  { city: 'Guadalajara', country: 'Mexico', timezone: 'America/Mexico_City' },
  { city: 'Monterrey', country: 'Mexico', timezone: 'America/Monterrey' },
  { city: 'Tijuana', country: 'Mexico', timezone: 'America/Tijuana' },
  
  // South America
  { city: 'São Paulo', country: 'Brazil', timezone: 'America/Sao_Paulo' },
  { city: 'Rio de Janeiro', country: 'Brazil', timezone: 'America/Sao_Paulo' },
  { city: 'Brasília', country: 'Brazil', timezone: 'America/Sao_Paulo' },
  { city: 'Buenos Aires', country: 'Argentina', timezone: 'America/Argentina/Buenos_Aires' },
  { city: 'Lima', country: 'Peru', timezone: 'America/Lima' },
  { city: 'Bogotá', country: 'Colombia', timezone: 'America/Bogota' },
  { city: 'Santiago', country: 'Chile', timezone: 'America/Santiago' },
  { city: 'Caracas', country: 'Venezuela', timezone: 'America/Caracas' },
  { city: 'Quito', country: 'Ecuador', timezone: 'America/Guayaquil' },
  { city: 'Montevideo', country: 'Uruguay', timezone: 'America/Montevideo' },
  
  // Europe
  { city: 'London', country: 'United Kingdom', timezone: 'Europe/London' },
  { city: 'Paris', country: 'France', timezone: 'Europe/Paris' },
  { city: 'Berlin', country: 'Germany', timezone: 'Europe/Berlin' },
  { city: 'Madrid', country: 'Spain', timezone: 'Europe/Madrid' },
  { city: 'Rome', country: 'Italy', timezone: 'Europe/Rome' },
  { city: 'Amsterdam', country: 'Netherlands', timezone: 'Europe/Amsterdam' },
  { city: 'Brussels', country: 'Belgium', timezone: 'Europe/Brussels' },
  { city: 'Vienna', country: 'Austria', timezone: 'Europe/Vienna' },
  { city: 'Stockholm', country: 'Sweden', timezone: 'Europe/Stockholm' },
  { city: 'Oslo', country: 'Norway', timezone: 'Europe/Oslo' },
  { city: 'Copenhagen', country: 'Denmark', timezone: 'Europe/Copenhagen' },
  { city: 'Dublin', country: 'Ireland', timezone: 'Europe/Dublin' },
  { city: 'Lisbon', country: 'Portugal', timezone: 'Europe/Lisbon' },
  { city: 'Prague', country: 'Czech Republic', timezone: 'Europe/Prague' },
  { city: 'Warsaw', country: 'Poland', timezone: 'Europe/Warsaw' },
  { city: 'Budapest', country: 'Hungary', timezone: 'Europe/Budapest' },
  { city: 'Athens', country: 'Greece', timezone: 'Europe/Athens' },
  { city: 'Zurich', country: 'Switzerland', timezone: 'Europe/Zurich' },
  { city: 'Barcelona', country: 'Spain', timezone: 'Europe/Madrid' },
  { city: 'Munich', country: 'Germany', timezone: 'Europe/Berlin' },
  { city: 'Milan', country: 'Italy', timezone: 'Europe/Rome' },
  { city: 'Moscow', country: 'Russia', timezone: 'Europe/Moscow' },
  { city: 'Istanbul', country: 'Turkey', timezone: 'Europe/Istanbul' },
  
  // Asia
  { city: 'Tokyo', country: 'Japan', timezone: 'Asia/Tokyo' },
  { city: 'Seoul', country: 'South Korea', timezone: 'Asia/Seoul' },
  { city: 'Beijing', country: 'China', timezone: 'Asia/Shanghai' },
  { city: 'Shanghai', country: 'China', timezone: 'Asia/Shanghai' },
  { city: 'Hong Kong', country: 'Hong Kong', timezone: 'Asia/Hong_Kong' },
  { city: 'Singapore', country: 'Singapore', timezone: 'Asia/Singapore' },
  { city: 'Bangkok', country: 'Thailand', timezone: 'Asia/Bangkok' },
  { city: 'Mumbai', country: 'India', timezone: 'Asia/Kolkata' },
  { city: 'Delhi', country: 'India', timezone: 'Asia/Kolkata' },
  { city: 'Bangalore', country: 'India', timezone: 'Asia/Kolkata' },
  { city: 'Dubai', country: 'United Arab Emirates', timezone: 'Asia/Dubai' },
  { city: 'Jakarta', country: 'Indonesia', timezone: 'Asia/Jakarta' },
  { city: 'Manila', country: 'Philippines', timezone: 'Asia/Manila' },
  { city: 'Kuala Lumpur', country: 'Malaysia', timezone: 'Asia/Kuala_Lumpur' },
  { city: 'Taipei', country: 'Taiwan', timezone: 'Asia/Taipei' },
  { city: 'Tel Aviv', country: 'Israel', timezone: 'Asia/Jerusalem' },
  { city: 'Riyadh', country: 'Saudi Arabia', timezone: 'Asia/Riyadh' },
  { city: 'Karachi', country: 'Pakistan', timezone: 'Asia/Karachi' },
  { city: 'Dhaka', country: 'Bangladesh', timezone: 'Asia/Dhaka' },
  { city: 'Ho Chi Minh City', country: 'Vietnam', timezone: 'Asia/Ho_Chi_Minh' },
  { city: 'Hanoi', country: 'Vietnam', timezone: 'Asia/Ho_Chi_Minh' },
  
  // Africa
  { city: 'Cairo', country: 'Egypt', timezone: 'Africa/Cairo' },
  { city: 'Lagos', country: 'Nigeria', timezone: 'Africa/Lagos' },
  { city: 'Nairobi', country: 'Kenya', timezone: 'Africa/Nairobi' },
  { city: 'Johannesburg', country: 'South Africa', timezone: 'Africa/Johannesburg' },
  { city: 'Cape Town', country: 'South Africa', timezone: 'Africa/Johannesburg' },
  { city: 'Casablanca', country: 'Morocco', timezone: 'Africa/Casablanca' },
  { city: 'Algiers', country: 'Algeria', timezone: 'Africa/Algiers' },
  { city: 'Accra', country: 'Ghana', timezone: 'Africa/Accra' },
  { city: 'Addis Ababa', country: 'Ethiopia', timezone: 'Africa/Addis_Ababa' },
  { city: 'Dakar', country: 'Senegal', timezone: 'Africa/Dakar' },
  
  // Oceania
  { city: 'Sydney', country: 'Australia', timezone: 'Australia/Sydney' },
  { city: 'Melbourne', country: 'Australia', timezone: 'Australia/Melbourne' },
  { city: 'Brisbane', country: 'Australia', timezone: 'Australia/Brisbane' },
  { city: 'Perth', country: 'Australia', timezone: 'Australia/Perth' },
  { city: 'Adelaide', country: 'Australia', timezone: 'Australia/Adelaide' },
  { city: 'Auckland', country: 'New Zealand', timezone: 'Pacific/Auckland' },
  { city: 'Wellington', country: 'New Zealand', timezone: 'Pacific/Auckland' },
  { city: 'Honolulu', country: 'United States', timezone: 'Pacific/Honolulu' },
  { city: 'Fiji', country: 'Fiji', timezone: 'Pacific/Fiji' },
];

/**
 * Search cities by name or country
 */
export function searchCities(query: string): Array<{ city: string; country: string; timezone: string }> {
  if (!query || query.trim() === '') {
    return [];
  }
  
  const normalized = query.toLowerCase().trim();
  return CITIES_DATABASE
    .filter(city => 
      city.city.toLowerCase().includes(normalized) ||
      city.country.toLowerCase().includes(normalized)
    )
    .slice(0, 12); // Limit to 12 results
}

/**
 * Get current time in a specific timezone
 */
export function getTimeInZone(timezone: string): Date {
  try {
    const timeString = new Date().toLocaleString('en-US', { timeZone: timezone });
    return new Date(timeString);
  } catch (error) {
    console.error(`Invalid timezone: ${timezone}`, error);
    return new Date(); // Fallback to local time
  }
}

/**
 * Get UTC offset for a timezone
 */
export function getUTCOffset(timezone: string): string {
  try {
    const date = new Date();
    
    // Get the timezone offset in minutes
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'shortOffset'
    });
    
    const parts = formatter.formatToParts(date);
    const offsetPart = parts.find(part => part.type === 'timeZoneName');
    
    if (offsetPart && offsetPart.value !== 'GMT') {
      return offsetPart.value.replace('GMT', 'UTC');
    }
    
    // Fallback: Calculate offset manually
    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
    const tzDate = new Date(date.toLocaleString('en-US', { timeZone: timezone }));
    const offset = (tzDate.getTime() - utcDate.getTime()) / (1000 * 60 * 60);
    
    const sign = offset >= 0 ? '+' : '-';
    const hours = Math.floor(Math.abs(offset));
    const minutes = Math.round((Math.abs(offset) - hours) * 60);
    
    return `UTC${sign}${hours}${minutes > 0 ? `:${minutes.toString().padStart(2, '0')}` : ''}`;
  } catch (error) {
    console.error(`Error getting UTC offset for ${timezone}:`, error);
    return 'UTC';
  }
}

/**
 * Format time based on format preference
 */
export function formatTime(date: Date, format: '12h' | '24h', showSeconds: boolean = false): string {
  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    ...(showSeconds && { second: '2-digit' }),
    hour12: format === '12h'
  };
  
  return date.toLocaleTimeString('en-US', options);
}

/**
 * Format date
 */
export function formatDate(date: Date, format: 'short' | 'long' = 'short'): string {
  if (format === 'long') {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
  
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  });
}

/**
 * Get user's local timezone
 */
export function getLocalTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Get local city name (best effort)
 */
export function getLocalCityName(): string {
  const timezone = getLocalTimezone();
  const parts = timezone.split('/');
  if (parts.length >= 2) {
    return parts[parts.length - 1].replace(/_/g, ' ');
  }
  return 'Local';
}
